'use client'

import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

type NotesDialog =
  | { kind: 'main' }
  | { kind: 'note'; elId: number }
  | null

interface NotesDialogValue {
  dialog: NotesDialog
  openMain: () => void
  openNote: (elId: number) => void
  close: () => void
}

const NotesDialogContext = createContext<NotesDialogValue | null>(null)

export function NotesDialogProvider({ children }: { children: ReactNode }) {
  const [dialog, setDialog] = useState<NotesDialog>(null)
  const value = useMemo<NotesDialogValue>(() => ({
    dialog,
    openMain: () => setDialog({ kind: 'main' }),
    openNote: (elId) => setDialog({ kind: 'note', elId }),
    close: () => setDialog(null),
  }), [dialog])

  return <NotesDialogContext.Provider value={value}>{children}</NotesDialogContext.Provider>
}

export function useNotesDialog(): NotesDialogValue {
  const value = useContext(NotesDialogContext)
  if (!value) throw new Error('useNotesDialog requires NotesDialogProvider')
  return value
}
